import moment from 'moment';

// Бэк отдаёт все date-time поля календаря в UTC (см. audit/calendar-api-reference.md).
// Хелперы переводят их в локальное время браузера для отображения/группировки
// и обратно в UTC ISO при отправке на бэк.

export const utcToLocalDate = (isoUtc) => (isoUtc ? moment.utc(isoUtc).local().format('YYYY-MM-DD') : '');

export const utcToLocalTime = (isoUtc) => (isoUtc ? moment.utc(isoUtc).local().format('HH:mm') : '');

// Значение для <input type="datetime-local">
export const utcToLocalDateTimeInput = (isoUtc) => (isoUtc ? moment.utc(isoUtc).local().format('YYYY-MM-DDTHH:mm') : '');

// 'YYYY-MM-DDTHH:mm' (локальное, из datetime-local инпута) -> ISO UTC для тела запроса
export const localDateTimeInputToUtcIso = (localDateTimeStr) => (
  localDateTimeStr ? moment(localDateTimeStr, 'YYYY-MM-DDTHH:mm').utc().toISOString() : null
);
